module.exports = __webpack_public_path__ + "static/media/course_2-photo.9b12c509.png";